export default __webpack_public_path__ + "media/images/map/leaflet/customIcons/map-marker-pink-e35f6441e7f93b98315a7eba6f6c6ae0.png";